import ScrollParallaxHomepageFirstFoldConfig from "./scroll-parallax-homepage-first-fold-config";
import ScrollParallaxHomepageFirstFoldAdvancedConfig from "./scroll-parallax-homepage-first-fold-advanced-config";
import dynamic from "next/dynamic";
const ScrollParallaxHomepageFirstFoldComponent = dynamic(()=>import("./scroll-parallax-homepage-first-fold-component"));
export default {
    ScrollParallaxHomepageFirstFoldComponent,
    ScrollParallaxHomepageFirstFoldConfig,
    ScrollParallaxHomepageFirstFoldAdvancedConfig
};
